import queryNetworkTopicSettings from '@ms/yammer-graphql/dist/operations/queryNetworkTopicSettings.graphql';
const apiName = 'NetworkTopicSettingsClients';

const apiRequestBody = {
  operationName: apiName,
  query: queryNetworkTopicSettings,
};

export const getCacheKey = (): string => apiName.concat(JSON.stringify(apiRequestBody));
